import React, { useContext, useEffect, useState } from 'react'
import { Alert, Container, Col, Button } from 'react-bootstrap'
import { DefaultSpinner } from '../pageBlocks/Spinners'
import { RouteComponentProps } from 'react-router'
import { ISignRouteParam } from '../../interfaces/i-signing-page'
import SigningStage from '../../constants/signingStages'
import DefaultSigningBlock from '../pageBlocks/DefaultSigningBlock'
import SigningBlock from '../pageBlocks/SigningBlock'
import SigningCompleteBlock from '../pageBlocks/SigningCompleteBlock'
import SigningContext from '../../contexts/SigningContext'
import { Trans, useTranslation } from 'react-i18next'
import appConfig from '../../app.config'
import httpClient from '../../services/httpClient'
import { VideoVerificationStatus } from '../../constants/videoIdValues'

function SignPage({ match }: RouteComponentProps<ISignRouteParam>) {
	const {
		fetchSigningRequest,
		signingRequest,
		signingStage,
		error,
		setError,
	} = useContext(SigningContext)
	const { t } = useTranslation()

	useEffect(() => {
		fetchSigningRequest(match.params.id, match.params.status)
	}, [fetchSigningRequest, match, signingStage])

	const [videoIdVerificationStatus, setVideoIdVerificationStatus] =
		useState<VideoVerificationStatus | null>(null)
	useEffect(() => {
		const fetchVideoIdVerificationStatus = async () => {
			if (!signingRequest) {
				setVideoIdVerificationStatus(null)
				return
			}
			const status =
				await httpClient.getSigningRequestByIdIncludingVideoIdVerificationStatus(
					signingRequest.id,
				)
			setVideoIdVerificationStatus(status?.videoVerificationStatus)
		}
		if (
			appConfig.country === 'de' &&
			signingStage === SigningStage.complete
		)
			fetchVideoIdVerificationStatus()
	}, [signingStage])

	function getRenderBlock() {
		if (!signingRequest) return null

		switch (signingStage) {
			case SigningStage.signing:
				return <SigningBlock />

			case SigningStage.complete:
				return appConfig.country === 'de' &&
					videoIdVerificationStatus !==
						VideoVerificationStatus.Accepted ? (
					<SigningBlock />
				) : (
					<SigningCompleteBlock />
				)

			default:
				return <DefaultSigningBlock />
		}
	}

	function BackToMerchant() {
		if (error) {
			return (
				<Col className="d-flex cancelLogin">
					<Button
						variant="outline-secondary"
						onClick={() => {
							window.location.replace(
								signingRequest ? signingRequest.failUrl : '',
							)
						}}>
						{t('Back to merchant')} &gt;
					</Button>
				</Col>
			)
		}
		return null
	}

	return (
		<Container id="SignPage">
			{!signingRequest && !error ? (
				<DefaultSpinner />
			) : (
				<>
					{error && (
						<Alert
							variant="danger"
							dismissible
							onClose={() =>
								signingRequest && setError(undefined)
							}>
							{error.message}
							{appConfig.country === 'de' ? (
								<Trans i18nKey={'ErrorMsgTryAgain'} />
							) : (
								''
							)}
						</Alert>
					)}

					{getRenderBlock()}
					{signingRequest?.failUrl ? <BackToMerchant /> : <></>}
				</>
			)}
		</Container>
	)
}

export default SignPage
